export default "__VITE_ASSET__bdc6e49f__"